import { api } from '@/utils/api';

export const useGlobalReminderDelete = () => {
  const utils = api.useUtils();
  return api.globalReminder.delete.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      // The contact-detail view renders reminders from the bootstrap query, so it must be
      // invalidated too — otherwise reminder changes aren't visible until a manual page refresh.
      // Scoped by contactId so we don't refetch every other cached contact's bootstrap data.
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadences2.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
      void utils.contact.getConnected.invalidate();
      void utils.contact.getConnectedGroupedByOrg.invalidate();
    },
  });
};

export const useGlobalReminderDeleteBulk = () => {
  const utils = api.useUtils();
  return api.globalReminder.deleteBulk.useMutation({
    onSuccess: () => {
      void utils.globalReminder.allForContact.invalidate();
      void utils.globalReminder.paginated.invalidate();
      // Bulk delete can hit multiple contacts; we don't have a per-contact list back here, so the
      // broad invalidate is the right call.
      void utils.contactDetailBootstrap.forContact.invalidate();
    },
  });
};

export const useGlobalReminderCreate = () => {
  const utils = api.useUtils();
  return api.globalReminder.create.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      // Reminders render off the contact-detail bootstrap query; invalidate it so a newly created
      // reminder shows up immediately instead of requiring a page refresh.
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadences2.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
    },
  });
};

export const useGlobalReminderUpdate = () => {
  const utils = api.useUtils();
  return api.globalReminder.update.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadences2.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
    },
  });
};

export const useGlobalReminderChangeOwner = () => {
  const utils = api.useUtils();
  return api.globalReminder.changeOwner.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadences2.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
    },
  });
};
